// extracted by mini-css-extract-plugin
export default {"drawer-banner-container":"ogD45lZKnY3Xszxl3TA7","banner-image":"mbRQc3eFGIbkZTCASiUB","short":"rS4gc992i2n4yNn3LkyH"};